import { useState, useCallback } from "react";

/**
 * Hook for managing ARIA live region announcements
 * Use this to announce dynamic content changes to screen readers
 */
export const useAriaLive = () => {
  const [announcement, setAnnouncement] = useState<string>("");
  const [priority, setPriority] = useState<"polite" | "assertive">("polite");

  const announce = useCallback(
    (message: string, announcePriority: "polite" | "assertive" = "polite") => {
      setAnnouncement("");
      setPriority(announcePriority);
      // Use setTimeout to ensure the message is cleared before setting new one
      // This forces screen readers to re-announce
      setTimeout(() => {
        setAnnouncement(message);
      }, 100);
    },
    []
  );

  return { announcement, priority, announce };
};




